import type { EventUnsubscribe } from '@spotar/runtime';
import {
  hasAudioPlaybackPermission,
  onAudioPlaybackPermitted,
} from '../audio-playback-permission';
import { hasSceneLoaded, onSceneLoaded } from '../scene-load-state';

const detachNothing: EventUnsubscribe = () => {};

/**
 * Triggers once the scene is loaded and the browser permits audio playback.
 * Both conditions are read as state rather than awaited as events, so a node
 * that subscribes after one of them already happened still fires.
 */
export function runOnStartImplementation(
  _data: Record<string, unknown>,
  triggerOutPortFunctions: Map<string, () => void>
): EventUnsubscribe {
  const triggerExec = triggerOutPortFunctions.get('exec');
  if (!triggerExec) return detachNothing;

  const triggerWhenReady = () => {
    if (!hasSceneLoaded() || !hasAudioPlaybackPermission()) return;
    triggerExec();
  };

  const detachListeners = [
    onSceneLoaded(triggerWhenReady),
    onAudioPlaybackPermitted(triggerWhenReady),
  ];

  // Catching up runs after the engine finished wiring the remaining nodes.
  queueMicrotask(triggerWhenReady);

  return () => {
    for (const detach of detachListeners) detach();
  };
}
